var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51273 33.75C5.06365 36.4417 8.50307 37.3665 11.1948 35.8156C11.1967 35.8146 11.1984 35.8135 11.2003 35.8124L12.0346 35.3305C13.6096 36.6781 15.42 37.7231 17.3746 38.413V39.375C17.3746 42.4816 19.893 45 22.9996 45C26.1062 45 28.6246 42.4816 28.6246 39.375V38.4131C30.5794 37.722 32.3899 36.6758 33.9645 35.3268L34.8027 35.8106C37.495 37.3639 40.9369 36.4405 42.4902 33.7481C44.0435 31.0557 43.1201 27.6138 40.4277 26.0605L39.5952 25.5806C39.9699 23.5414 39.9699 21.451 39.5952 19.4118L40.4277 18.9318C43.12 17.3785 44.0435 13.9367 42.4902 11.2443C40.9369 8.55193 37.4951 7.62847 34.8027 9.18176L33.9683 9.66366C32.3917 8.31779 30.5801 7.27471 28.6246 6.58687V5.625C28.6246 2.51842 26.1062 0 22.9996 0C19.893 0 17.3746 2.51842 17.3746 5.625V6.58687C15.4197 7.27796 13.6093 8.32421 12.0346 9.67315L11.1965 9.18756C8.50404 7.63418 5.06224 8.55765 3.50895 11.25C1.95566 13.9424 2.87904 17.3842 5.57148 18.9375L6.40398 19.4175C6.02921 21.4566 6.02921 23.547 6.40398 25.5863L5.57148 26.0662C2.88651 27.6237 1.96612 31.0588 3.51273 33.75ZM22.9996 15C27.1417 15 30.4995 18.3579 30.4995 22.5C30.4995 26.6421 27.1417 30 22.9996 30C18.8575 30 15.4996 26.6421 15.4996 22.5C15.4996 18.3579 18.8575 15 22.9996 15Z",
    fill: "#00FFE0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.533da8c13b15203a23e80cb73dec9fbe.svg";
export { ForwardRef as ReactComponent };